export default "__VITE_ASSET__cb951c1f__"